export default "__VITE_ASSET__DSxUkpID__"